<template>
<div>
    <div class="promise" v-show="isShowPromise">
        <div class="promise-item">
            <img src="../../../assets/images/homePage_new/home_icon_mianfeishiting_pc.png" alt="" class="promise-item-pic">
            <div style="margin-left:20px">
                <div class="promise-item-name">免费试听承诺</div>
                <div class="promise-item-text">首节测评课免费试听<br>满意后再付费上课</div>
            </div>
        </div>
        <div class="promise-item" style="margin-left:23px">
            <img src="../../../assets/images/homePage_new/home_icon_huanlaoshi_pc.png" alt="" class="promise-item-pic">
            <div style="margin-left:20px">
                <div class="promise-item-name">随时换老师承诺</div>
                <div class="promise-item-text">任何时候对老师不满意<br>均可申请更换老师</div>
            </div>
        </div>
        <div class="promise-item" style="margin-left:18px">
            <img src="../../../assets/images/homePage_new/home_icon_bumanyi_pc.png" alt="" class="promise-item-pic">
            <div style="margin-left:20px">
                <div class="promise-item-name">效果不满意，退余额</div>
                <div class="promise-item-text">课程不满意，支持退款，退款会扣除已上课时费和服务费</div>
            </div>
        </div>
    </div>
    <div class="app-footer" :class="{
        'app-footer--simple':simple
    }">
        <div class="app-footer__container">
            <div class="footer-main" v-show="!simple">
                <div class="hot-line">
                    <span class="hot-line__text">学习服务热线</span>
                    <span class="hot-line__phone">4008-180-190</span>
                    <router-link class="hot-line__publicity" :to="{name:'publicityCommitment'}">线上培训机构备案承诺公示</router-link>
                    <span class="hot-line__warning">投诉举报电话：4008-180-190</span>
                </div>
                <ul class="link-list link-list--1">
                    <li class="link-list__title">服务与支持</li>
                    <li class="link-list__item">
                        <router-link class="link-list__link" :to="{name:'user-agreement'}" target="_blank">用户协议/</router-link>
                        <router-link class="link-list__link" :to="{name:'privacy-agreement'}" target="_blank">隐私政策/</router-link>
                        <router-link class="link-list__link" :to="{name:'child-privary-policy'}" target="_blank">儿童隐私政策</router-link>
                    </li>
                </ul>
                <ul class="link-list link-list--2">
                    <li class="link-list__title">友情链接</li>
                    <li class="link-list__item">
                        <a class="link-list__link" href="http://www.yunxiao.com/" target="_blank">云校官网</a>
                    </li>
                    <li class="link-list__item">
                        <a class="link-list__link" href="http://paike.yunxiao.com/" target="_blank">云校排课</a>
                    </li>
                    <li class="link-list__item">
                        <a class="link-list__link" href="http://bbs.yunxiao.com/" target="_blank">云校论坛</a>
                    </li>
                    <li class="link-list__item">
                        <a class="link-list__link" href="https://hfs.yunxiao.com/" target="_blank">好分数</a>
                    </li>
                </ul>
                <div class="qr-codes">
                    <div class="qr-codes__item">
                        <img class="qr-codes__img"
                            src="../../../assets/images/homePage_new/home_qr_sc.png"
                            alt="辅导商城小程序">
                        <span class="qr-codes__text">辅导商城小程序</span>
                    </div>
                    <div class="qr-codes__item">
                        <img class="qr-codes__img"
                            src="../../../assets/images/homePage_new/home_qr_gzh.png"
                            alt="好分数辅导微信公众号">
                        <span class="qr-codes__text">好分数辅导微信公众号</span>
                    </div>
                </div>
            </div>
            <div class="company-info">
                <span class="company-info__item">北京市海淀区东升科技园学院八号</span>
                <i class="company-info__separator"></i>
                <span class="company-info__item">2014-2021 北京修齐治平科技有限公司</span>
                <i class="company-info__separator"></i>
                <span class="company-info__item">
                    <a target="_blank" href="https://beian.miit.gov.cn/">
                        京ICP备16000182号-5
                    </a>
                </span>
                <i class="company-info__separator"></i>
                <span class="company-info__item">
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042360">
                        <img src="../../../assets/images/common/gaba.png" class="footer-gaba">京公网安备11010502042360号
                    </a>
                </span>
            </div>
        </div>
        <el-dialog title="课时包介绍" width="580px" :visible.sync="PriceDialog" class="price-dialog">
            <p class="one-one">好分数辅导1对1价格表</p>
            <div class="table">
                <div class="tr">
                    <div class="th">年级</div>
                    <div class="th">基础课时价格</div>
                    <div class="th">高级课时价格</div>
                    <!--<div class="th">vip课时价格</div>-->
                </div>
                <div class="tr" v-for="item in priceContent" :key="item.grade">
                    <div class="td">{{ item.gradeStr }}</div>
                    <div class="td">{{ item.basicPrice }}</div>
                    <div class="td">{{ item.seniorPrice }}</div>
                    <!--<div class="td">{{ item.vipPrice }}</div>-->
                </div>
            </div>
        </el-dialog>
    </div>
</div>
</template>

<script>
import { Grade3 } from '../../../constants/enum';
export default {
    props: {
        simple: {
            type: Boolean,
            default: true
        },
        isShowPromise: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            PriceDialog: false,
            priceContent: [],
            Grade3
        };
    },
    methods: {
        handlePriceDialog() {
            this.$http.get('/v1/config/pricing')
                .then(resp => this.$checkResp(resp, []))
                .then(data => {
                    data.forEach(item => {
                        item.gradeStr = Grade3[item.grade];
                        item.basicPrice = +(item.originalPrice[0] / 100).toFixed(2);
                        item.seniorPrice = +(item.originalPrice[1] / 100).toFixed(2);
                        item.vipPrice = +(item.originalPrice[2] / 100).toFixed(2);
                    });
                    this.priceContent = data;
                    this.PriceDialog = true;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.app-footer {
    min-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding-top: 30px;
    padding-bottom: 20px;
    background: #414141;
    &__container {
        width: 1200px;
        margin: 0 auto;
    }
    &--simple {
        background: none;
        padding-top: 0px;
    }
}
.footer-main {
    height: 130px;
    margin-bottom: 20px;
    display: flex;
}
.hot-line {
    flex: none;
    width: 200px;
    margin-right: 134px;
    margin-left: 92px;

    &__text {
        display: block;
        font-size: 18px;
        font-weight: bold;
        color: #CCCCCC;
        line-height: 25px;
        margin-bottom: 11px;
    }
    &__phone {
        display: block;
        padding-left: 29px;
        font-size: 20px;
        color: #FFFFFF;
        font-weight: bold;
        margin-bottom: 20px;
        background: url('../../../assets/images/homePage_new/home_img_rx.png') no-repeat left center / 20px;
    }
    &__warning {
        display: block;
        font-size: 12px;
        color: #CCCCCC;
        // font-weight: bold;
        margin-top: 20px;
    }
    &__publicity {
        display: block;
        font-size: 12px;
        color: #CCCCCC;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
}
.link-list {
    &__title {
        display: block;
        margin-bottom: 10px;
        font-size: 16px;
        color: #FAFAFA;
        line-height: 22px;
    }
    &__item {
        display: block;
        line-height: 17px;
        font-size: 12px;
        margin-bottom: 10px;
    }
    &__link {
        color: #CCCCCC;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
    &--1 {
        flex: none;
        width: 242px;
    }
    &--2 {
        flex: 1;
    }
}
.qr-codes {
    display: flex;

    &__item {
        width: 120px;
        text-align: center;
    }
    &__img {
        display: block;
        width: 100px;
        margin: 0 auto;
        margin-bottom: 15px;
        border: 4px solid #fff;
        border-radius: 2px;
    }
    &__text {
        font-size: 12px;
        color: rgba(152, 152, 152, .6);
        line-height: 17px;
    }
}

.company-info {
    display: flex;
    align-items: center;
    justify-content: center;

    a:hover {
        color: #999999;
        text-decoration: none;
    }
    a:link {
        color: #999999;
        text-decoration: none;
    }
    a:active {
        color: #999999;
        text-decoration: none;
    }
    a:visited {
        color: #999999;
        text-decoration: none;
    }

    &__item {
        font-size: 12px;
        color: #999999;
        line-height: 17px;
    }
    &__separator {
        display: block;
        width: 1px;
        height: 8px;
        background: #999;
        margin: 0 10px;
    }
    .footer-gaba {
        margin-bottom: -4px;
    }
}
.price-dialog {
    /deep/ .el-dialog__header {
        padding-top: 25px;
        padding-left: 40px;
    }
    /deep/ .el-dialog__title {
        font-size: 18px;
        color: #333;
        font-weight: 500;
    }
    /deep/ .el-dialog__headerbtn {
        top: 30px;
        right: 40px;
    }
    /deep/ .el-dialog__body {
        padding: 10px 40px 20px;
    }
    .one-one {
        margin-bottom: 15px;
        font-size: 14px;
        color: #333;
    }
    .table {
        width: 100%;
        margin-bottom: 20px;
        .tr {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #f6f6f6;
            border-top: none;
            &:first-of-type {
                border: none;
            }
            .th {
                width: 33.3%;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: none;
                background-color: #FF4D2B;
                color: #fff;
                &:first-of-type {
                    border-radius: 4px 0 0 0;
                }
                &:last-of-type {
                    border-radius: 0 4px 0 0;
                }
            }
            .td {
                width: 33.3%;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #333;
                &:last-of-type {
                    border-right: none;
                }
            }
        }
    }
}
.price-introduce {
    font-size: 12px;
    padding: 0;
    color: #ccc;
}
.promise {
    display: flex;
    width: 1200px;
    margin: 30px auto;
    .promise-item {
        display: flex;
        width: 385px;
        background: #FFFFFF;
        background: #FFFFFF;
        box-shadow: 0 10px 14px 0 rgba(0,0,0,0.06);
        border-radius: 2px;
        padding: 18px 0 20px;
    }
    .promise-item-pic {
        width: 34px;
        height: 40px;
        margin-left: 70px;
    }
    .promise-item-name {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0.08px;
    }
    .promise-item-text {
        width: 196px;
        margin-top: 10px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #666666;
        letter-spacing: 0.05px;
        line-height: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/AppFooter.vue